import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);
import axios from "axios";




import {apiDomain}from './config.js'
export default new Vuex.Store({
  strict: true,
  
  state: {
   sidebarShow: 'responsive',
   sidebarMinimize: false,
    loggedIn: false,
    user: null,
   
    token: null,
    active:'',

     notification:[],
     messagesRec:[],
     messageSent:[],
     message:{
       text:'',
       to:'',
       from:'',
     },





  },
  plugins: [new VuexPersistence().plugin],

  mutations: {
    toggleSidebarDesktop (state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile (state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set (state, [variable, value]) {
      state[variable] = value
    },
/* start chat */
SET_MESSAGES_REC(state , messages) {
state.messagesRec = messages
},

SET_MESSAGES_SENT(state , messages) {
  state.messageSent = messages
  },

  NEW_PM_NOTIFICATIONS(state,message) {
    state.messagesRec.unshift(message)
  },


    allpost(state,payload){
      return state.post = payload
  },
  
  siglePost(state,payload){
      return state.singlepost = payload
  },

   


    
    FETCH_CONTACTANNONCE(state, contactAnnonces) {
      return state.contactAnnonces = contactAnnonces
    },


      
    //fetch usres
    FETCH_USERS(state, users) {
      return state.users = users
    }, 
    //fetch cats
    FETCH_CATS(state, categotries) {
      return state.categotries = categotries
    },
    
    FETCH_USERprofile(state, userProfiles) {
      return state.userProfiles = userProfiles
    },








    SET_user(state, payload) {
      state.user = payload;
    },
    
    SET_token(state, payload) {
      state.token = payload;
    },
    SET_loggedIn(state, payload) {
      state.loggedIn = payload;
    },

    
    FETCH_ENT(state, entreprises) {
      return state.entreprises = entreprises
    }, 
    
  },
  actions: {
   setUserMessagesRec:({commit}) => {
       let postData = {}
       return Vue.http.post(getMsgContact,postData ,{headers:getHeader()})
           .then(response => {
             Vue.$logger('info','setUserMessagesRec response' , response)
             commit('SET_MESSAGES_REC' ,response.text.data)
           })
            
   },


   newMessageNotifiaction:({commit},message) => {
     commit('NEW_PM_NOTIFICATIONS',message)
   },
/* end acrion ,,chat */
//client
performLoginClientAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiDomain}/api/auth/login`, {
            login: payload.login,
            password: payload.password
          })
          .then(res => {
            commit("SET_token", res.data.access_token);
            commit("SET_user", res.data.user);
         
            commit("SET_loggedIn", true);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    performRegisterClientAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiDomain}/api/auth/register`, {
            nom: payload.nom,
            prenom: payload.prenom,
            login: payload.login,
            password: payload.password
          })
          .then(res => {
            commit("SET_token", res.data.access_token);
            commit("SET_user", res.data.user);
            commit("SET_loggedIn", true);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

   
    performLogoutAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiDomain}/api/auth/logout`, {
            token: state.token
          })

          .then(res => {
            commit("SET_token", null);

            commit("SET_loggedIn", false);
            commit("SET_user", null);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    updateUserProfileAction({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`${apiDomain}/api/auth/update`, {
            
            
            nom: payload.nom,
            prenom: payload.prenom,
            telephone: payload.telephone,
        
  
            adresse: payload.adresse,
            age: payload.age,
            //genre: this.user.genre,
            email: payload.email,
//enteprise
            service_entreprise: payload.service_entreprise,
          descri_ser_entreprise: payload.descri_ser_entreprise,
          nom_entreprise: payload.nom_entreprise,
          photo_entreprise: payload.photo_entreprise,
          local_entreprise: payload.local_entreprise,
          nb_annee_exp_entreprise: payload.nb_annee_exp_entreprise,
          patente_entreprise: payload.patente_entreprise,
          desponobilite_entreprise: payload.desponobilite_entreprise,






            token: state.token
          })
          .then(res => {
            commit("SET_user", res.data.user);

            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
 
  },
  getters: {

 
categotries: state => {
  return state.categotries
},


contacts: state => {
  return state.contactAnnonces
},
users: state => {
  return state.users
},

    
  userProfiles: state => {
    return state.userProfiles
},
  
  user: state => {
    return state.user
},






    get_loggedIn(state) {
      return state.loggedIn;
    },
    get_user(state) {
      return state.user;
    },
    
    //get enreprise
    
    get_entreprises: state => {
      return state.entreprises
  },


  }
});
